angular.module('zc.zenclerkS')
  .controller('UsersSignInController', UsersSignInController);

UsersSignInController.$inject = [
  '$scope',
  '$translate',
  '$window',
  'afterLoginHandler',
  'Api',
  'ColorMeShop',
  'Devise',
  'Environment',
  'localStorageService',
  'Page',
  'returnUrl',
  'Shopify',
  'ZcTag',
];
/* eslint-disable angular/di-order */
function UsersSignInController(
  $scope,
  $translate,
  $window,
  afterLoginHandler,
  Api,
  ColorMeShop,
  Devise,
  Environment,
  localStorageService,
  Page,
  returnUrl,
  Shopify,
  ZcTag,
) {

  const vm = this;
  vm.user = {
    email: '',
    password: '',
    remember_me: true
  };
  vm.showForgot = false;
  vm.forgotHasBeenSubmitted = false;
  vm.login = login;
  vm.toggleForgot = toggleForgot;
  vm.forgot = forgot;
  vm.shopifyShopName = '';
  vm.shopifyShopDomain = '.myshopify.com';
  vm.showShopifyLogin = false;
  vm.shopifyLogin = shopifyLogin;
  vm.toggleShopifyLogin = toggleShopifyLogin;
  vm.setLanguage = setLanguage;
  vm.environment = 'production';
  vm.enableAuth0 = $window.ZC_CONFIG.ENABLE_AUTH0;
  vm.loginWithAuth0 = loginWithAuth0;

  ColorMeShop.getLoginUrl().then(loginUrl => {
    vm.loginUrlForColorMeShop = loginUrl;
  });

  Environment.get()
    .then(environment => {
      vm.environment = environment;
    });

  // To ensure user to read updated angular app.
  $scope.$on('$locationChangeSuccess', function() {
    // Devise.currentUser == undefined means never logined
    if(angular.isDefined(Devise.currentUser) && $window.location.pathname === '/users/sign_in') {
      localStorageService.clearAll();
      return $window.location.reload();
    }
  });
  $translate('users.signIn.login').then(translation => Page.setTitle(translation));
  Page.setBodyClass('account-bg');

  function setLanguage(lang) {
    $translate.use(lang);
    $window.document.documentElement.lang = lang;
  }

  // Login
  //#############################################################################

  function login(user) {
    ZcTag.sendParticularEvent('users.signIn.login:submit', { remember_me: user.remember_me });
    return Devise.signIn(user.email, user.password, user.remember_me).then(function(res) {
      ZcTag.sendParticularEvent('users.signIn.login:success');
      return afterLoginHandler.handle(res);
    });
  }

  // Forgot password
  //#############################################################################

  // Toggle the forgot form
  function toggleForgot() {
    vm.showForgot = !vm.showForgot;
  }
  // Send new password to user
  function forgot(email) {
    vm.forgotHasBeenSubmitted = true;
    ZcTag.sendParticularEvent('users.signIn.forgotPassword:submit');
    Devise.sendPasswordResetInstructions(email);
    vm.toggleForgot();
  }

  // Shopify login and redirect
  function shopifyLogin() {
    Shopify.getLoginUrl(`${vm.shopifyShopName}${vm.shopifyShopDomain}`).then(loginUrl => {
      if(loginUrl) {
        $window.location.href = loginUrl;
      }
    });
  }

  // Toggle the shopify login form
  function toggleShopifyLogin() {
    vm.showShopifyLogin = !vm.showShopifyLogin;
  }

  function loginWithAuth0() {
    const returnPath = returnUrl.get() || '';
    $window.location.href = `${Api.basePath}/users/auth/login?origin=${$window.location.origin}${returnPath}`;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/users/sign_in/users_sign_in.controller.js